export enum PartComponentEnum {
  Part = 0,
  Component = 1,
  PurchasedParts = 2,
}

export const partComponentMap: Record<number, string> = {
  [PartComponentEnum.Part]: 'Part',
  [PartComponentEnum.Component]: 'Component',
  [PartComponentEnum.PurchasedParts]: 'Purchased Parts',
};
